/**
 * The branch's wall-clock time as a local `Date` (its fields read the branch's
 * hours/minutes), or the device clock when the branch has no timezone.
 */
export function getBranchTime(timezone: string | null | undefined, now: Date = new Date()): Date {
  if (!timezone) return now;
  try {
    return new Date(now.toLocaleString("en-US", { timeZone: timezone }));
  } catch {
    return now;
  }
}
